import { lazy, Suspense, useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import type { LeadRecord } from '@flashpoint/site-dna';
import { onLeadSnapshot } from '../lib/firestore';

const EditorInner = lazy(() => import('../vfs/EditorInner'));

export function EditPage() {
  const { id } = useParams<{ id: string }>();
  const [lead, setLead] = useState<LeadRecord | null | undefined>(undefined);

  useEffect(() => {
    if (!id) return;
    return onLeadSnapshot(id, setLead);
  }, [id]);

  if (!id) return null;
  if (lead === undefined) return <div className="font-mono text-sm text-nm-muted">Loading…</div>;

  if (lead?.provisioning.codeLocked) {
    return (
      <div className="space-y-3">
        <Link to={`/leads/${id}`} className="text-xs text-nm-muted hover:text-nm-ink">
          &larr; Back to lead
        </Link>
        <div className="fp-card">
          <h2 className="font-display text-lg font-semibold text-nm-ink">Locked — live project</h2>
          <p className="mt-2 text-sm text-nm-muted">
            File editing is disabled. Flashpoint will not push to this GitHub repo.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <Link to={`/leads/${id}`} className="text-xs text-nm-muted hover:text-nm-ink">
        &larr; Back to lead
      </Link>
      <Suspense fallback={<div className="text-sm text-nm-muted">Loading VFS engine...</div>}>
        <EditorInner leadId={id} />
      </Suspense>
    </div>
  );
}
